import { getSelectedCalendarsFromTimePanel } from './getSelectedCalendarsFromTimePanel';
import { hasTimePanelSelectedCalendars } from './hasTimePanelSelectedCalendars';
import { ObservableMap } from 'mobx';
import { getSelectedCalendars as getSelectedCalendarsFromCalendarModule } from 'owa-calendar-module-selected-calendars-user-config';

/**
 * Gets selected calendarIds as a map of accounts to calendarIds, preferably from Time Panel config
 * if non-empty or else fall back to Calendar module config
 */
export function getTimePanelSelectedCalendarIdsMap(): ObservableMap<string, string[]> {
    if (hasTimePanelSelectedCalendars()) {
        return getSelectedCalendarsFromTimePanel();
    } else {
        // if time panel selected calendars have not been set, fall back to showing the calendar modules selected calendars
        return getSelectedCalendarsFromCalendarModule();
    }
}
